<h1 mat-dialog-title>{{ 'calibrateEquipmentEdit.dialog.confirmSave.title' | translate }}</h1>
<form [formGroup]="form">
  <div mat-dialog-content class="calibrates-theme">

    @if (data.showReason) {
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'calibrateEquipmentEdit.dialog.confirmSave.reason.label' | translate }}</mat-label>
        <textarea matInput
          [(ngModel)]="data.reason" formControlName="reason" [errorStateMatcher]="matcher" style="resize: none;"
        required></textarea>
        <mat-error>
          {{ 'calibrateEquipmentEdit.dialog.confirmSave.reason.error' | translate }}
        </mat-error>
      </mat-form-field>
    }

  </div>
  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>

    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'button.save' | translate
    }}</button>

    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>